<template>
  <div class="fff">
    <div class="page_title">{{ $t("take.txt1") }}</div>
    <div class="Take">
      {{ $t("take.txt2") }}
    </div>
    <div class="twoButton">
      <div class="BackButton">{{ $t("take.txt3") }}</div>
      <div class="loginButton">{{ $t("take.txt4") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "",
    };
  },
  mounted() {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 100%;
  position: absolute;
  height: 100%;
  background: #fff;
  overflow: hidden;
}
.Take {
  font-size: 14px;
  color: grey;
  line-height: 20px;
  margin-left: 5%;
  width: 85%;
  max-width: 800px;
}
</style>



// WEBPACK FOOTER //
// src/components/Take.vue